import { useEffect, useContext, useState, useCallback } from 'react'
import moment from 'moment-timezone'
import styled from 'styled-components'

import { H6 } from '../../H6'
import { colors, fontWeights } from '../../../utils'
import { UserContext } from '../../../context'
import { TimezoneGlobe } from './TimezoneGlobe'
import { useDateTime } from '../../../hooks'

const Container = styled.div`
  display: flex;
  align-items: baseline;
  color: ${colors.purple};
  fontweight: ${fontWeights.semiBold};

  /* Clear uppercase off heading */
  .dateAndTime {
    text-transform: unset;
  }
`

// Props.
interface Props {
  dateTime: string
  className?: string
  getDisplayTime?: (dateText: string, timeText: string) => string
}

export const DateAndTime: React.FC<Props> = (props) => {
  const { dateTime } = props
  if (!dateTime) {
    return null
  } else {
    return <DateAndTimeInner {...props} />
  }
}

const DateAndTimeInner: React.FC<Props> = ({
  dateTime,
  className,
  getDisplayTime,
}) => {
  const displayTime = useDateTime(dateTime, {
    dateFormat: 'ddd, MMM DD, YYYY',
    getDisplayTime,
  })

  return (
    <Container className={className}>
      <H6 className="dateAndTime">{displayTime}</H6>

      {/* Ask User to set time zone */}
      <TimezoneGlobe />
    </Container>
  )
}
